import { SVGProps } from 'react';

interface PlayIconProps extends SVGProps<SVGSVGElement> {
	colorFill?: string;
	colorLine?: string;
}

export const PlayIcon = ({ colorFill, colorLine }: PlayIconProps) => (
	<svg
		width="22"
		height="22"
		viewBox="0 0 22 22"
		fill={colorFill || 'none'}
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="Icon / Play">
			<path
				id="Vector"
				d="M10.9995 18.4156C15.095 18.4156 18.4151 15.0955 18.4151 11C18.4151 6.90453 15.095 3.58447 10.9995 3.58447C6.90404 3.58447 3.58398 6.90453 3.58398 11C3.58398 15.0955 6.90404 18.4156 10.9995 18.4156Z"
				stroke={colorLine || 'white'}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				id="Polygon 7"
				d="M14.3766 10.2206C14.9766 10.567 14.9766 11.433 14.3766 11.7794L9.98617 14.3142C9.38617 14.6606 8.63617 14.2276 8.63617 13.5348L8.63617 8.4652C8.63617 7.77238 9.38617 7.33937 9.98617 7.68578L14.3766 10.2206Z"
				fill={colorLine || 'white'}
			/>
		</g>
	</svg>
);
